/**
 * 将字节数转换为合适的计算机单位（KB, MB, GB）
 * @param {number} bytes
 * @returns {string}
 */
export function formatBytes(bytes) {
  if (isNaN(bytes) || bytes < 0) return "0 B";
  const units = ["B", "KB", "MB", "GB", "TB"];
  let i = 0;
  while (bytes >= 1024 && i < units.length - 1) {
    bytes /= 1024;
    i++;
  }
  return `${bytes.toFixed(2)} ${units[i]}`;
}
/**

 * @param {*} urls 
 * @returns {Array<{url,fileName,}} 返回一个包含文件信息的对象列表
 */
export function urlListToFileInfoList(urls) {
  // 1. 先生成对象列表（含url、fileName、timestamp），同步返回
  const fileInfoList = urls.map((url) => {
    const { fileName, timestamp } = getFileNameAndTimestampFromUrl(url);
    console.log("fileName:", fileName, "timestamp:", timestamp);
    return {
      url,
      fileName,
      uploadTime: Number(timestamp + "000"),
      size: null,
      updateTime: null,
    };
  });

  // 2. 异步补充 size 和 updateTime
  // fileInfoList.forEach(async (info) => {
  //   try {
  //     const res = await fetch(info.url, { method: "HEAD" });
  //     info.size = Number(res.headers.get("content-length")) || 0;
  //     info.updateTime = res.headers.get("last-modified") || "";
  //   } catch (e) {
  //     info.size = 0;
  //     info.updateTime = "";
  //   }
  // });

  // 3. 直接返回对象列表引用
  return fileInfoList;
}

/**
 * 从文件URL中提取文件名和时间戳
 * 假设文件名格式为 [时间戳]-[文件名]，如 '1718000000000-report.pdf'
 * @param {string} url
 * @returns {{ fileName: string, timestamp: string|null }}
 */
export function getFileNameAndTimestampFromUrl(url) {
  if (!url) return { fileName: "", timestamp: null };
  let fileName = "";
  try {
    const pathname = new URL(url).pathname;
    fileName = decodeURIComponent(
      pathname.substring(pathname.lastIndexOf("/") + 1)
    );
  } catch {
    const parts = url.split("/");
    fileName = decodeURIComponent(parts[parts.length - 1] || "");
  }
  const match = /^(\d+)-(.+)$/.exec(fileName);
  if (match) {
    return { fileName: match[2], timestamp: match[1] };
  }
  return { fileName, timestamp: null };
}

/**
 * 从文件URL中提取文件名
 * @param {string} url
 * @returns {string}
 */
export function getFileNameFromUrl(url) {
  if (!url) return "";
  try {
    const pathname = new URL(url).pathname;
    const fileName = decodeURIComponent(
      pathname.substring(pathname.lastIndexOf("/") + 1)
    );
    // 去掉时间戳（假设时间戳和文件名之间用 '-' 连接）
    const idx = fileName.indexOf("-");
    return idx !== -1 ? fileName.substring(idx + 1) : fileName;
  } catch {
    // 如果不是有效的URL，尝试简单处理
    const parts = url.split("/");
    const fileName = decodeURIComponent(parts[parts.length - 1] || "");
    const idx = fileName.indexOf("-");
    return idx !== -1 ? fileName.substring(idx + 1) : fileName;
  }
}
